var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column h-100",class:_vm.$store.state.bg_class,attrs:{"id":"app"}},[_c('app-bar'),(_vm.configLoaded)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }